import logoMark from './logo-mark.png?url';

/**
 * 全站品牌图形（与语言无关）。资源来自 Vite 打包的 PNG，使用 `?url` 保证开发/生产路径稳定。
 */
export function brandLogoUrl(): string {
  return logoMark;
}
